export enum ExcelDataType {
  number = 'number',
  string = 'string',
  date = 'date',
  boolean = 'boolean'
}

export enum ProcessStatus {
  Started = 1,
  InProgress = 2,
  Stopped = 3,
  Failed = 4,
  Completed = 5
}

export class UploadResult {
  succeeded: boolean;
  errorMessage: string;
  fileName: string;

  constructor() {
      this.succeeded = true;
      this.errorMessage = "";
      this.fileName = "";
  }
}

export class UploadFileResult {
  result: UploadResult;
  tmpDirectoryName: string;

  constructor() {
      this.result = new UploadResult();
      this.tmpDirectoryName = "";
  }
}

export class UploadProgress {
  totalStep: number;
  currentStep: number;

  constructor(totalStep: number, currentStep: number) {
      this.totalStep = totalStep;
      this.currentStep = currentStep;
  }
}

export class Process {
  ProcessId: number;
  ReferenceId: number;
  StatusId: number;
  TotalCount: number;
  FinishedCount: number;
  Description: string;
  Status: boolean;

  constructor() {
      this.ProcessId = 0;
      this.ReferenceId = 0;
      this.StatusId = 0;
      this.TotalCount = 0;
      this.FinishedCount = 0;
      this.Description = '';
      this.Status = true;
  }
}
